import { render, staticRenderFns } from "./CampoPlazo.vue?vue&type=template&id=36923575&scoped=true&"
import script from "./CampoPlazo.vue?vue&type=script&lang=js&"
export * from "./CampoPlazo.vue?vue&type=script&lang=js&"
import style0 from "./CampoPlazo.vue?vue&type=style&index=0&id=36923575&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36923575",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36923575')) {
      api.createRecord('36923575', component.options)
    } else {
      api.reload('36923575', component.options)
    }
    module.hot.accept("./CampoPlazo.vue?vue&type=template&id=36923575&scoped=true&", function () {
      api.rerender('36923575', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoPlazo.vue"
export default component.exports